import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Button, CircularProgress, Container, Grid, Paper, TextField, Typography } from '@material-ui/core';
import { RequestStatus, stores } from 'mobx-store/index';
import { observer } from 'mobx-react';
import SnackBarComponent from 'components/SnackBarComponent/SnackBarComponent';
import { useHistory, useParams } from 'react-router';

const RenewIwthPointsScreen = observer(() => {
  const history = useHistory();
  const { search, pathname } = history.location;
  const queryParams = new URLSearchParams(search);
  const { deglawyContentStore, } = stores;
  const cardsDeliveryFess = queryParams.get('cardsDeliveryFess');
  const membershipId = queryParams.get('membershipId');
  const requestId = queryParams.get('requestId');


  useEffect(() => {
    deglawyContentStore.getUserPointsInfoIframe(membershipId!, +cardsDeliveryFess! || 0);
  }, []);


  const onPayClick = async () => {
    await deglawyContentStore.payUserPointsInfoIframe(membershipId!, +cardsDeliveryFess! || 0, requestId!);
    if (deglawyContentStore.payPointsState === RequestStatus.SUCCESS) {
      SnackBarComponent.getInstance().openSnackbar('Saved sucussfully', 8000, 'success');
      queryParams.set('success', 'true');
      history.push(`${pathname}?${queryParams.toString()}`);
    } else if (deglawyContentStore.payPointsState === RequestStatus.FAILED) {
      queryParams.set('success', 'false');
      queryParams.set('data.message', deglawyContentStore.error);
      history.push(`${pathname}?${queryParams.toString()}`);
      SnackBarComponent.getInstance().openSnackbar(deglawyContentStore.error, 8000, 'error');
    }
  };
  const onCancelClick = () => {
    queryParams.set('success', 'false');
    queryParams.set('data.message', deglawyContentStore.error);
    history.push(`${pathname}?${queryParams.toString()}`)
  };

  if (deglawyContentStore.iframePointsState === RequestStatus.LOADING) {
    return <Container component="main" maxWidth="xs" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <CircularProgress />
    </Container>
  }

  if (deglawyContentStore.iframePointsState === RequestStatus.FAILED) {
    return <Container component="main" maxWidth="xs" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Typography variant='body1' color='error'>Something wentwrong</Typography>
    </Container>
  }

  if (deglawyContentStore.iframePointsState === RequestStatus.SUCCESS) {
    return (
      <Container component="main" maxWidth="sm" style={{ textAlign: 'center' }}>
        <Paper elevation={3} style={{ padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <img src="https://upload.wikimedia.org/wikipedia/ar/0/08/Wadi_Degla_Logo.png" alt="Logo" style={{ marginBottom: '20px', maxHeight: 140 }} />

          <Typography variant="h6" gutterBottom>
            Renew with points
          </Typography>

          <Typography variant="body1" gutterBottom >
            You will pay amount {deglawyContentStore.iframePoints.amount} EGP with points {deglawyContentStore.iframePoints.points}
          </Typography>

          <Grid container spacing={1}>
            <Grid item xs={12} md={6}>
              <Button variant="contained" color="primary" onClick={onPayClick} fullWidth>
                {deglawyContentStore.payPointsState === RequestStatus.LOADING ?
                  'Submitting...' :
                  'Pay'}
              </Button>
            </Grid>
            <Grid item xs={12} md={6}>
              <Button variant="contained" color="secondary" onClick={onCancelClick} fullWidth>
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Container >
    );
  }
  return (
    null
  )

});

export default RenewIwthPointsScreen;